import LegalLayout from "./LegalLayout"

export default function MentionsLegales() {
  return (
    <LegalLayout>

      <h2>Éditeur du site</h2>

      <table className="legal-table">
        <tbody>
          <tr>
            <th>Dénomination sociale</th>
            <td>A.B.M.J. SRL</td>
          </tr>

          <tr>
            <th>Nom commercial</th>
            <td>Friterie de Lalaing</td>
          </tr>

          <tr>
            <th>BCE</th>
            <td>0898.575.732</td>
          </tr>

          <tr>
            <th>TVA</th>
            <td>BE0898.575.732</td>
          </tr>

          <tr>
            <th>Adresse</th>
            <td>
              Rue de la Grande Ronce 7<br />
              7190 Écaussinnes<br />
              Belgique
            </td>
          </tr>

          <tr>
            <th>Responsable</th>
            <td>Joséphine Coppens</td>
          </tr>

          <tr>
            <th>Email</th>
            <td>lalaing@abjmnets.com</td>
          </tr>

          <tr>
            <th>Téléphone</th>
            <td>067 33 99 39</td>
          </tr>
        </tbody>
      </table>

      <h2>Hébergement</h2>
      <p>
        Frontend : Hostinger<br />
        Backend : Fly.io
      </p>

      <h2>Activité</h2>
      <p>
        La Friterie de Lalaing propose la vente de plats à emporter,
        boissons soft et bières, avec commande en ligne et retrait sur place.
      </p>

    </LegalLayout>
  )
}